import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomNotification } from 'common/components';
import * as extMeetingServices from 'services/ext-meeting';
import { setAnnoInfo } from 'utils/common/session';

export const anonUserInfoKey = ['user-info', 'anon'];

export function useAnonLogin() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (params) => {
      const res = await extMeetingServices.anonLoginForMeeting(params);
      return res;
    },
    onSuccess: (response, variables) => {
      const { isSuccess, data, message } = response || {};

      if (!isSuccess) {
        CustomNotification.error(message || 'Anonymous login failed');
        return;
      }

      const { meetingUniqueId, ...userBasicInfo } = variables;
      const anonUserInfo = {
        ...userBasicInfo,
        ...data,
        isAnonymous: true,
        href: window.location.href,
        id: data?.userChatId,
        member: { id: null },
      };

      setAnnoInfo(anonUserInfo);

      qc.setQueryData(anonUserInfoKey, anonUserInfo);
    },
    onError: () => {
      CustomNotification.error('Failed to login as a guest');
    },
  });
}
